import { useTranslation } from 'react-i18next';
import { ProfileForm } from '../../components/profile-form/profile-form';
import { PageHeader } from '@/components/core';

export const ProfileBuilderPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full flex-col gap-4">
      <PageHeader title={t('ADD_PROFILE')} />
      <ProfileForm />
    </div>
  );
};
